const FR = {
  'rvr.interior.image-1.hotspot-1.label': 'Volant et tableau de bord',
  'rvr.interior.image-1.hotspot-1.message': 'Volant et tableau de bord',
  'rvr.interior.image-1.hotspot-2.label': 'Climatisation',
  'rvr.interior.image-1.hotspot-2.message': 'Climatisation',
  'rvr.interior.image-1.hotspot-3.label': 'Levier de vitesses et console centrale',
  'rvr.interior.image-1.hotspot-3.message': 'Levier de vitesses et console centrale',
  'rvr.interior.image-1.hotspot-4.label': 'Siège du conducteur',
  'rvr.interior.image-1.hotspot-4.message': 'Siège du conducteur',
  'rvr.interior.image-1.hotspot-5.label': 'Connectivité et infodivertissement',
  'rvr.interior.image-1.hotspot-5.message': 'Connectivité et infodivertissement',

  'rvr.interior.image-2.hotspot-1.label': 'Commodités de la 2e rangée',
  'rvr.interior.image-2.hotspot-1.message': 'Commodités de la 2e rangée',
  'rvr.interior.image-2.hotspot-2.label': 'Sièges garnis de cuir',
  'rvr.interior.image-2.hotspot-2.message': 'Sièges garnis de cuir',
  'rvr.interior.image-2.hotspot-3.label': 'Caractéristiques de sécurité active',
  'rvr.interior.image-2.hotspot-3.message': 'Caractéristiques de sécurité active',
  'rvr.interior.image-2.hotspot-4.label': 'Ceintures et systèmes de retenue',
  'rvr.interior.image-2.hotspot-4.message': 'Ceintures et systèmes de retenue',

  'rvr.exterior.hotspot-1.label': 'Moteur et transmission',
  'rvr.exterior.hotspot-1.message': 'Moteur et transmission',
  'rvr.exterior.hotspot-2.label': 'Contrôle intégral',
  'rvr.exterior.hotspot-2.message': 'Contrôle intégral',
  'rvr.exterior.hotspot-3.label': 'Roues et pneus',
  'rvr.exterior.hotspot-3.message': 'Roues et pneus',
  'rvr.exterior.hotspot-4.label': 'Hayon et bouchon de carburant',
  'rvr.exterior.hotspot-4.message': 'Hayon et bouchon de carburant',
  'rvr.exterior.hotspot-5.label': 'Caractéristiques de sécurité active',
  'rvr.exterior.hotspot-5.message': 'Caractéristiques de sécurité active',

  'rvr.blueprint.safety.tab-1': 'Coussins gonflables latéraux en rideau',
  'rvr.blueprint.safety.tab-2': 'Coussin gonflable pour genoux du conducteur',
  'rvr.blueprint.safety.tab-3': 'Coussins gonflables frontaux doubles',
  'rvr.blueprint.safety.tab-4': 'Coussins gonflables latéraux montés aux sièges avant',
  'rvr.blueprint.safety.hotspot-1.label': 'Coussins latéraux en rideau (1re et 2e rangée)',
  'rvr.blueprint.safety.hotspot-1.message': 'Coussins latéraux en rideau (1re et 2e rangée)',
  'rvr.blueprint.safety.hotspot-2.label': 'Coussin pour genoux du conducteur',
  'rvr.blueprint.safety.hotspot-2.message': 'Coussin pour genoux du conducteur',
  'rvr.blueprint.safety.hotspot-3.label': 'Coussins frontaux doubles',
  'rvr.blueprint.safety.hotspot-3.message': 'Coussins frontaux doubles',
  'rvr.blueprint.safety.hotspot-4.label': 'Coussins latéraux montés aux sièges avant',
  'rvr.blueprint.safety.hotspot-4.message': 'Coussins latéraux montés aux sièges avant',

  'rvr.launcher.introduction': "Cliquez pour poser des questions sur l'RVR",
}

export default FR
